import { render, staticRenderFns } from "./DailyWork.vue?vue&type=template&id=c8345d56&scoped=true"
import script from "./DailyWork.vue?vue&type=script&lang=js"
export * from "./DailyWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8345d56",
  null
  
)

export default component.exports